/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForDockerHub extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForDockerHub");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForDockerHub.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForDockerHub>): ServiceAccountNativeDetailsForDockerHub {
        let obj = Object.assign(new ServiceAccountNativeDetailsForDockerHub(), model);
        ServiceAccountNativeDetailsForDockerHub.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForDockerHub>): ServiceAccountNativeDetailsForDockerHub {
        if (!model) return null;
        return ServiceAccountNativeDetailsForDockerHub.newInstance(<ServiceAccountNativeDetailsForDockerHub> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForDockerHub) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForDockerHub.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForDockerHub): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForDockerHub.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
